import React, { useState } from 'react';
import Icons from '../../../../../components/Common/Icons/Icons';
import PageSubHeader from '../../../Common/PageSubHeader';
import AccountManagementPrevUser from './Prev';
import CreateUserForm from './Form';

export type InvalidFields = Partial<Record<keyof IAccountManagementCreateUser, boolean>>;
export interface IAccountManagementCreateUser {
  primaryUserId: string;
  secondaryUserId: string;
  firstName: string;
  lastName: string;
  type: string;
}

const defaultValues: IAccountManagementCreateUser = {
  primaryUserId: '',
  secondaryUserId: '',
  firstName: '',
  lastName: '',
  type: '',
};

const defaultValidateState: InvalidFields = {
  primaryUserId: false,
  firstName: false,
  lastName: false,
};

function AccountManagementCreateUser() {
  const [state, setState] = useState<IAccountManagementCreateUser>(defaultValues);
  const [showPrev, setShowPrev] = useState<boolean>(false);

  const [invalidFields, setInvalidFields] = useState<InvalidFields>(defaultValidateState);

  const handleInputChange = (key: keyof IAccountManagementCreateUser, value: string) => {
    setState({ ...state, [key]: value });
    handleValidate(key, value);
  };

  const handleReset = () => {
    setState(defaultValues);
    setShowPrev(false);
    setInvalidFields(defaultValidateState);
  };

  const handleSubmit = () => {
    const newInvalidFields: InvalidFields = { ...invalidFields };

    Object.entries(state).forEach(([key, value]) => {
      if (key in invalidFields) {
        newInvalidFields[key as keyof IAccountManagementCreateUser] = !value.length;
      }
    });

    setInvalidFields(newInvalidFields);

    if (Object.values(newInvalidFields).some(el => el)) {
      return;
    }

    setShowPrev(true);
  };

  const handleValidate = (key: keyof IAccountManagementCreateUser, value: string) => {
    setInvalidFields(prevState => ({ ...prevState, [key]: !value.length }));
  };

  const handleBack = () => {
    setShowPrev(false);
  };

  return (
    <div>
      <PageSubHeader
        leftContent={
          <div className="flex items-center gap-2">
            <Icons.UserAccount className="size-6" />
            <span>Account Management</span>
          </div>
        }
        breadcrumbs={[
          { path: '/infoTrac/', label: <Icons.HomeOutlined />, disableBg: true },
          { path: '/infoTrac', label: 'InfoTRAC' },
          { path: '/infoTrac/account-management', label: 'Account Management' },
        ]}
      />

      <div className="mt-[30px] bg-[#F8F9FD] shadow-lg max-w-[690px] rounded-lg p-[30px] mx-auto self-center">
        <div className="mb-[25px] flex gap-[20px] items-start">
          <div className="bg-[#307BB2] p-[10px] rounded-lg">
            <Icons.UserManagement className="[&_path]:fill-white w-[15px] h-[15px]" />
          </div>
          <div>
            <div className="font-bold text-xl leading-[24px]">User Creation</div>
            <div className="opacity-60">Some text description</div>
          </div>
        </div>
        {!showPrev ? (
          <CreateUserForm
            state={state}
            handleReset={handleReset}
            handleSubmit={handleSubmit}
            handleInputChange={handleInputChange}
            invalidFields={invalidFields}
            handleValidate={handleValidate}
          />
        ) : (
          <AccountManagementPrevUser handleBack={handleBack} state={state} />
        )}
      </div>
    </div>
  );
}

export default AccountManagementCreateUser;
